
const ParentName = ["总经理:总经理", "总监:总监", "会计:会计", "出纳:出纳",
  "助理:助理", "仓管员:仓管员", "质管员:质管员", "销售员:销售员", "部门经理:部门经理",
  "普通员工:普通员工"];

const flowName = [
  "SaleOrder: eMES销售订单", "SAPSaleOrder: sAP销售订单",
];

const statusText = [
  "启用: 启用", "禁用: 禁用",
];
const LiftType = [
  "Homelift Small cabinet: Homelift Small cabinet",
  "Homelift New cabinet: Homelift New cabinet",
  "Homelift Door frame type: Homelift Door frame type",
  "Passenger - Atlas Basic: Passenger - Atlas Basic",
  "Atlas Basic Door Frame type: Atlas Basic Door Frame type",
  "Passenger-Atlas Basic C7000 MRL: Passenger-Atlas Basic C7000 MRL",
  "Passenger-EN81.20 Controller: Passenger-EN81.20 Controller",
];

const repairMan = [
  "张峰: 张峰", "吴伟龙: 吴伟龙", "金鸣华: 金鸣华","范晓华: 范晓华",
];
const shipmentInvoiceStatus = [
  "全部: 全部", "已打印下发: 已打印下发",
];

const inspectionTypes = [
  "210: 蒂森有机房",
  "220: 蒂森无机房",
  "230: 奥的斯备库",
];

const deliveryType = [
  "顺丰: 顺丰",
  "优速: 优速",
  "汽运: 汽运",
  "自提: 自提",
  "京东: 京东",
  "其他: 其他",
];
const environment = [
  "粉尘: 粉尘",
  "灰尘: 灰尘",
  "潮湿: 潮湿",
  "高温: 高温",
  "低温: 低温",
  "高原: 高原",
  "普通: 普通",
];
const stage = [
  "安装: 安装",
  "使用: 使用",
];
const isTechnicalSupport = [
  "已支持: 已支持",
  "无需支持: 无需支持",
];

const materialType1 = [
  "动力线: 动力线",
  "连接线: 连接线",
];
const faultType = [
  "无电源: 无电源",
  "通讯故障: 通讯故障",
  "上电炸机: 上电炸机",
  "开关门故障: 开关门故障",
  "操作器无法连接: 操作器无法连接",
  "程序错误: 程序错误",
  "过流过压保护: 过流过压保护",
  "溜车超速故障: 溜车超速故障",
  "程序升级失败: 程序升级失败",
  "显示异常: 显示异常",
  "欠压缺相: 欠压缺相",
  "运行抖动噪声: 运行抖动噪声",
  "编码器PG卡故障: 编码器PG卡故障",
  "其他: 其他",
];
const materialType = [
  "电源类（抱闸电源，开关电源，应急电源，四合一电源）: 电源类（抱闸电源，开关电源，应急电源，四合一电源）",
  "操纵箱/外呼盒 （含显示器）: 操纵箱/外呼盒 （含显示器）",
  "操作器 : 操作器",
  "主板: 主板",
  "轿厢板轿顶板: 轿厢板轿顶板",
  "指令板（03板）: 指令板（03板）",
  "显示板: 显示板",
  "按钮 （包含文字片）: 按钮（包含文字片）",
  "插件板: 插件板",
  "一体机: 一体机",
  "接触器(包含触点，开关，漏保，保险丝座）: 接触器(包含触点，开关，漏保，保险丝座）",
  "控制柜: 控制柜",
  "辅助类板卡: 辅助类板卡",
  "钣金件: 钣金件",
  "轿顶箱/底坑盒/急停盒: 轿顶箱/底坑盒/急停盒",
  "线缆类: 线缆类",
  "对讲机/光电开关/平层开关: 对讲机/光电开关/平层开关",
  "人机类: 人机类",
  "物联网/刷卡系统: 物联网/刷卡系统",
  "一体机附板: 一体机附板",
  "大线: 大线",
  "接触器类: 接触器类",
  "井道配件: 井道配件",
  "小线缆: 小线缆",
  "钣金类: 钣金类",
  "按钮类: 按钮类",
  "其他: 其他",
];
const problemType = [
  "10: 漏件",
  "20: 故障",
  "25: 质量",
  "30: 运输损坏",
  "40: 客户要求",
  "50: 内联单/变更单",
  "51: 订单后补",
  "60: 其他",
];
const problemType2 = [
  "10: 错件",
  "20: 故障",
  "25: 质量",
  "30: 运输损坏",
  "40: 客户要求",
  "50: 内联单/变更单",
  "51: 订单后补",
  "60: 其他",
];
const responsibleDepartment = [
  "电气待分析: 电气待分析",
  "电机待分析: 电机待分析",
  "供应商待分析: 供应商待分析",
  "销售/文员: 销售/文员",
  "生产: 生产",
  "合同: 合同",
  "技术: 技术",
  "研发: 研发",
  "客户: 客户",
  "其他: 其他",
];

const stationCode = [
  "ECCL1-1: ECCL1-1",
  "ECCL1-2: ECCL1-2",
  "ECCL1-3: ECCL1-3",
  "ECCL1-4: ECCL1-4",
  "ECCL1-5: ECCL1-5",
  "ECCL1-6: ECCL1-6",
  "ECCL1-7: ECCL1-7",
  "ECCL1-8: ECCL1-8",
  "ECCL1-9: ECCL1-9",
  "ECCL1-10: ECCL1-10",
];
const problemClassification_KZG = [
  "安装问题: 安装问题",
  "物料问题: 物料问题",
  "标签问题: 标签问题",
  "附件问题: 附件问题",
  "接线问题: 接线问题",
  "铭牌问题: 铭牌问题",
  "配置问题: 配置问题",
  "程序问题: 程序问题",
  "变更问题: 变更问题",
  "项目阶段问题: 项目阶段问题",
  "其他: 其他",
];
const problemClassification_RJ = [
  "外观问题: 外观问题",
  "安装问题: 安装问题",
  "订单问题: 订单问题",
  "配置问题: 配置问题",
  "其他: 其他",
];
const problemClassification_LL = [
  "缺物料: 缺物料",
  "外观不良: 外观不良",
  "型号不良: 型号不良",
  "性能不良: 性能不良",
  "标识/结构不良: 标识/结构不良",
  "尺寸不良: 尺寸不良",
  "缺件: 缺件",
  "其他: 其他",
];
const qualitativeClassification = [
  "A类: A类",
  "B类: B类",
];

const RISK_CLASS = [
  "A: 高风险",
  "B: 中风险",
  "C: 低风险",
  " : ",
];

const BLOCK_REASON = [
  "01: 已超过信贷限额",
  "02: 不足分数",
  "03: 欺诈风险",
  "04: 不可保险",
];

//销售订单多选特性
const checkGroupList = [
  "DMLine",//门机线
  "ATSPOptions",//特别选项
  "EVOptions",//电梯选项
  "CCOptions",//控制柜选项
  "CableType",//Cable Type
  "SPfeedback",//Speed feedback
  "PCOptions",//门机选项
  "Intercom",//Intercom
  "IFARD",//ARD
  "WCOptions",//井道线缆选项
  "COPSurface",//COP Surface
  "ACOOptions",//声光选项
  "COPNameplate",//COP Nameplate
  "COPBtnOptions",//COP按钮选项
  "COPKSOptions",//COP钥匙开关选项
  "COPOption",//COP选项
  "COPSurface2",//COP Surface(副板)
  "ACOOptions2",//声光选项(副板)
  "COPNameplate2",//COP Nameplate(副板)
  "COPBtnOptions2",//COP按钮选项(副板)
  "COPKSOptions2",//COP钥匙开关选项(副板)
  "COPOption2",//COP选项(副板)
  "LOPSurface",//LOP Surface
  "LOPBtnOptions",//LOP Button Options
  "LOPKeySWOptions",//LOP Key Switch Options
  "LOPOptions",//LOP Options
  "ODPOptions",//
  "MONTOptions",//
];

//销售订单input框
const inputList = [
  "FBSwitchNum",//折叠护栏开关数量
  "LiftSpeed",//Lift Speed
  "LiftLoad",//Lift Load
  "NoOfLift",//No. of Lift
  "ARSpeed",//实际运行速度
  "NBLifts",//Number of Lifts
  "NBFloors",//No. of Floors
  "NBCarEntrances",//Number of Car Entrances
  "NBOpenings",//No. of Openings
  "FrontOpening",//开前门
  "RearOpening",//开后门
  "AllOpening",//前后双开门
  "MLMarking",//Main Lobby Marking
  "PhaseInput",//Phase input
  "Hertz",//Hertz
  "InputWires",//Input wires  L1,L2,L3,N,PE
  "MotorModel",//Motor Model
  "MotorCapacity",//Motor capacity
  "Voltage",//Voltage
  "RRSpeed",//Rated rotation speed
  "RatedCurrent",//Rated Current
  "ACTVoltage",//Activating Voltage
  "HoldVoltage",//Hold Voltage
  "BrandofDD",//Brand of Door Drive
  "DoorSafetySupply",//Door safety supply
  "HFCONTToTFloor",//Height from controller to top floor
  "TTravelLift",//Total Travel of Lift
  "DistanceFSToCONT",//The distance from Shaft to Controller
  "DistanceFCToMB",//The distance from the Controller to the motor/brake
  "OverheadHeight",//Overhead Height
  "PitDepth",//Pit Depth
  "DistFHCToShaft",//The distance from hall call to shaft
  "DistFHBToFIndicator",//The distance from hall button to floor indicator
  "height",//Floor to Floor Height
  "floor",//
  "ShaftWidth",//Shaft width
  "ShaftDepth",//Shaft depth
  "DPXCBPline",//Duplex cable并联线
  "NoLOPs",//No. of LOPs
  "MainFlOn",//Main floor on
  "BDBCneeded",//Blue dot-matrix display SM.04VRM boards and connection cable needed
  "NOPwDMEHH130",//No. of panels with dot matrix display EHH130
  "NOPwLCDLCHLCDonG",//No. of panels with LCD display LCHL CD on G floor*
];

const radioGroupList = [
  "ProjectType",//项目类型
  "Socket",//插座
  "FireBox",//消防盒
  "MTFireBox",//消防盒材质
  "FireMode",//消防模式
  "MPSupply",//Main Power Supply
  "TypeofGroup",//Type of Group
  "TypeofControl",//Type of Control
  "MotorType",//Motor Type
  "GearType",//Gear Type
  "DoorSafety",//Door safety
  "ArrivalGong",//Arrival gong
  "VoiceANNC",//Voice announcement
  "COPModel",//COP Model
  "COPBtnModel",//COP Button Model
  "COPIndicator",//COP Indicator
  "COPModel2",//COP Model
  "COPBtnModel2",//COP Button Model(副板)
  "COPIndicator2",//COP Indicator(副板)
  "LOPModel",//LOP Model
  "LOPBtnModel",//LOP Button Model
  "LOPIndicator",//LOP Indicator
];

const taxCode = [
  "JD:13%进项税，中国",
  "JG:6%进项税，中国",
  "K5:1%进项税，中国",

];

// const departmentName = [
//   "总经办:总经办", "企业发展部:企业发展部",
//   "海外事业部:海外事业部","人力资源部:人力资源部","财务部:财务部",
//   "审计部:审计部","行政技术部:行政技术部","技术委员会:技术委员会",
//   "研发中心:研发中心","可靠性分析部:可靠性分析部","研发管理部:研发管理部",
//   "IT部:IT部","质量部:质量部","合同部:合同部","技术部:技术部",
//   "生产部:生产部","物流部:物流部","成品发运部:成品发运部","营销中心:营销中心",
//   "市场部:市场部","产品拓展部:产品拓展部","售前技术支持部:售前技术支持部",
//   "西部区:西部区","上海区:上海区","华南区:华南区","北方区:北方区",
//   "售后服务部:售后服务部","STEPSoft:STEPSoft","VIP客户订单处理:VIP客户订单处理",
//   "谊新国际:宜新国际","工艺及标准化部:工艺及标准化部","苏州区:苏州区",
//   "江苏区:江苏区","杭州区:杭州区","大客户部:大客户部","谊新财务部:谊新财务部",
//   "新时达股份:新时达股份","采购管理中心:采购管理中心","战略采购部:战略采购部",
//   "电机运营中心:电机运营中心","电机质量部:电机质量部","数据部:数据部",
//   "电机数据部:电机数据部","电机工艺部:电机工艺部","产品中心:产品中心",
//   "部件开发部:部件开发部","器件部:器件部","驱动产品研发:驱动产品研发",
//   "出口销售中心:出口销售中心","东南亚业务部:东南亚业务部","欧洲业务部:欧洲业务部",
//   "工控业务部:工控业务部","总经理办公室:总经理办公室",
//   "技术支持及售后服务中心:技术支持及售后服务中心","运控产品研发:运控产品研发",
//   "新时达运控事业部:新时达运控事业部","运控产品部:运控产品部",
//   "运控客服服务部:运控客服服务部","运控软件部:运控软件部","运控结构部:运控结构部",
//   "电气技术部:电气技术部","客户服务中心:客户服务中心","技术支持部:技术支持部",
//   "电机合同执行部:电机合同执行部","电梯硬件部:电梯硬件部","新时达电缆:新时达电缆",
//   "工艺部:工艺部","高压产品线:高压产品线","网络营销部:网络营销部",
//   "南浔区:南浔区","信息中心:信息中心","测试部门:测试部门","品质部:品质部",
//   "采购部:采购部","制造部:制造部","工程部:工程部","策划部:策划部",
//   "部件生产部:部件生产部","生产管理部:生产管理部","电气生产部:电气生产部",
//   "仓储部:仓储部","部门:部门","物联网研发部:物联网研发部",
// ];

let exportObj = {
  //departmentName,
  ParentName,
  flowName,
  statusText,
  repairMan,
  shipmentInvoiceStatus,
  inspectionTypes,
  stationCode,
  RISK_CLASS,
  BLOCK_REASON,
  LiftType,
  problemClassification_KZG,
  problemClassification_RJ,
  problemClassification_LL,
  qualitativeClassification,
  checkGroupList,
  inputList,
  radioGroupList,
  taxCode,
  deliveryType,
  materialType,
  materialType1,
  problemType,
  problemType2,
  responsibleDepartment,
  environment,
  stage,
  isTechnicalSupport,
  faultType,
};

//------------------------------以下部分请勿改动------------------------------
//转化为object和options
for (let key in exportObj) {
  let value = exportObj[key];
  if (Array.isArray(value)) {
    let options = [];
    let object = {};
    value.forEach(item => {
      let itemArr = item.split(":");
      let option = {
        value: itemArr[0],
        label: itemArr[1],
      };
      object[option.value] = option.label;
      options.push(option);
    });
    value.$options = options;
    value.$object = object;
  }
}
export default exportObj;
